module.exports = __webpack_public_path__ + "logo-b712b73958ab592cd45bb5262eb142fa.png";